module.exports = __webpack_public_path__ + "static/img/y32.2c40f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y32.jpg
// module id = FFRE
// module chunks = 1